<template>
    <div id="background" style="height: 100%;
    width: 100%;
    position:fixed;
    background: url(/static/images/xinhengfeng/blackbg.png) no-repeat;
    background-attachment: fixed;
    background-size: cover;
    height: 100%;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;">



        <div id="main_container" style="height: 100%;width: 100%;">



            <!--防伪&商品信息开始 showAntiPopup -->
            <div v-if="showAntiPopup">

                <div style="position: absolute;display: flex;justify-content: center;
                        margin: -6% 0%; /* 上下自动，左右15% */
                        border: 0px solid;
                        text-align: center;z-index: 99;;width: 100%;height: 50px;opacity: 1;">
                    <div
                        style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
                        <p
                            style="background: url(/static/images/barcode.png);background-size: cover;width: 30px;height: 30px;">
                        </p>
                    </div>
                </div>
                <div class="modal-anti">
                    <div style="margin-top: 14%;display: flex;flex-direction: column;text-align: left;">
                        <div>
                            <span style="color: white;font-size: 1rem;">产品名称：</span>
                            <span style="color: white;font-size: 1rem;" v-text="productName"></span>
                        </div>
                        <div style="margin-top: 20px;">
                            <span style="color: white;font-size: 1rem;">产品型号：</span>
                            <span style="color: white;font-size: 1rem;" v-text="productNo"></span>
                        </div>
                        <p style="color: white;font-size: 0.8rem;;margin-top: 14px;text-align: center;"
                            v-html="antiresult"></p>

                        <div v-if="showActivity"
                            style="width: 100%;height: fit-content;display: flex;justify-content: center;align-items: center;">
                            <div :disabled="isDisabled"
                                style="z-index: 11;;width: 200px;height: 35px;margin-top: 30px;background-color:rgb(214,180,105); border-radius: 20px;display: flex;align-items: center;"
                                @click="joinActivity">
                                <span
                                    style="width: 100%;;text-align: center;font-size: 1rem;color: #FFFFFF;">领取积分</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!-- 防伪&商品信息结束 -->




            <!--用户手机号姓名采集  -->
            <div v-if="showUserInfoSet">

                <div style="position: absolute;display: flex;justify-content: center;
        margin: -6% 0%; /* 上下自动，左右15% */
        border: 0px solid;
        text-align: center;z-index: 99;;width: 100%;height: 50px;opacity: 1;">
                    <div
                        style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
                        <p
                            style="background: url(/static/images/barcode.png);background-size: cover;width: 30px;height: 30px;">
                        </p>
                    </div>
                </div>
                <div class="modal-anti">
                    <div
                        style="margin-top: 5%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                        <div style="text-align: center;">
                            <span style="color: white;font-size: 1rem;">填写个人信息<br />领取积分</span>
                        </div>


                        <div style="margin-top: 12px;text-align: center;height:30px;width: 100%;">

                            <input type="text" name="text" class="input" placeholder="请输入姓名" v-model="name" />

                        </div>
                        <div style="margin-top:20px;text-align: center;height:30px;width: 100%;">
                            <input type="tel" name="text" class="input" placeholder="请输入手机号" v-model="tel" maxlength="11" />

                        </div>

                        <div v-if="showActivity"
                            style="width: 100%;height: fit-content;display: flex;justify-content: center;align-items: center;">
                            <div :disabled="isDisabled"
                                style="z-index: 11;;width: 210px;height: 35px;margin-top: 40px;background-color:rgb(214,180,105); border-radius: 20px;display: flex;align-items: center;"
                                @click="setUserInfo">
                                <span
                                    style="width: 100%;;text-align: center;font-size: 1rem;color: #FFFFFF;font-weight: bold;">领取积分</span>
                            </div>
                            <!-- <button class="Btn-Container" @click="setUserInfo">
                                <span class="text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;提交信息</span>
                                <span class="icon-Container">
                                    <svg width="16" height="19" viewBox="0 0 16 19" fill="nones"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="1.61321" cy="1.61321" r="1.5" fill="black"></circle>
                                        <circle cx="5.73583" cy="1.61321" r="1.5" fill="black"></circle>
                                        <circle cx="5.73583" cy="5.5566" r="1.5" fill="black"></circle>
                                        <circle cx="9.85851" cy="5.5566" r="1.5" fill="black"></circle>
                                        <circle cx="9.85851" cy="9.5" r="1.5" fill="black"></circle>
                                        <circle cx="13.9811" cy="9.5" r="1.5" fill="black"></circle>
                                        <circle cx="5.73583" cy="13.4434" r="1.5" fill="black"></circle>
                                        <circle cx="9.85851" cy="13.4434" r="1.5" fill="black"></circle>
                                        <circle cx="1.61321" cy="17.3868" r="1.5" fill="black"></circle>
                                        <circle cx="5.73583" cy="17.3868" r="1.5" fill="black"></circle>
                                    </svg>
                                </span>
                            </button> -->

                        </div>

                    </div>
                </div>
            </div>
            <!-- 防伪&商品信息结束 -->



            <!--中奖成功弹框开始-->
            <div v-if="showSuccessTip">
                <div style="position: absolute;display: flex;justify-content: center;
                        margin: -6% 0%; /* 上下自动，左右15% */
                        border: 0px solid;
                        text-align: center;z-index: 88;;width: 100%;height: 50px;opacity: 1;">
                    <div
                        style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
                        <p
                            style="background: url(/static/images/star.png);background-size: cover;width: 33px;height: 30px;">
                        </p>
                    </div>
                </div>
                <div class="modal-anti">
                    <div style="margin-top: 8%;display: flex;flex-direction: column;text-align: left;">

                        <p style="color: white;font-size: 1.2rem;margin-top: 10px;text-align: center;"
                            v-html="getScoreTip"></p>
                        <p style="color: white;margin-top: 30px;text-align: center;">
                            <span style="font-size: 2.2rem;color:rgb(248, 206, 70);font-weight: bold;"
                                v-html="getScore"></span>
                            <span style="font-size: 1.2rem;">积分</span>
                        </p>
                        <wx-open-launch-weapp id="launch-btn" :appid="miniAppId" :username="miniAppOriginalId"
                            :path="miniAppPage">
                            <script type="text/wxtag-template">
                                        <input type="button" value="前往商城" style="border: none;
                                                            z-index: 0;
                                                            color: white;
                                                            padding: 8px 30px;
                                                            text-align: center;
                                                            text-decoration: none;
                                                            display: block;
                                                            font-size: 14px;
                                                            border-radius: 20px;
                                                            margin-left: 14%;
                                                            margin-top: 25px;background-color:rgb(214,180,105);
                                                            width: 200px;height: 35px;"/>
                                    </script>
                        </wx-open-launch-weapp>
                    </div>
                </div>
            </div>
            <!-- 中奖成功弹框结束 -->




            <!--中奖错误弹框开始  -->
            <div v-if="showErrorTip">
                <div style="position: absolute;display: flex;justify-content: center;
                        margin: -6% 0%; /* 上下自动，左右15% */
                        border: 0px solid;
                        text-align: center;z-index: 88;;width: 100%;height: 50px;opacity: 1;">
                    <div
                        style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
                        <p
                            style="background: url(/static/images/star.png);background-size: cover;width: 33px;height: 30px;">
                        </p>
                    </div>
                </div>
                <div class="modal-anti">
                    <div style="margin-top: 14%;display: flex;flex-direction: column;text-align: left;">

                        <p style="color: white;font-size: 1.2rem;;margin-top: 10px;text-align: center;"
                            v-html="errorTip"></p>
                        <!-- <p style="color: white;font-size: 1.2rem;;margin-top: 14px;text-align: center;">抱歉</p> 
                            <p style="color: white;font-size: 1.2rem;;margin-top: 14px;text-align: center;">此码已参与积分</p>
                            <p style="color: white;font-size: 1.2rem;;margin-top: 14px;text-align: center;">感谢您的支持</p> -->
                        <!-- <span style="width: 100%;;text-align: center;font-size: 1rem;color: #FFFFFF;">前往商城</span> -->
                        <wx-open-launch-weapp id="launch-btn" :appid="miniAppId" :username="miniAppOriginalId"
                            :path="miniAppPage">
                            <script type="text/wxtag-template">
                                        <input type="button" value="前往商城" style="border: none;
                                                            z-index: 0;
                                                            color: white;
                                                            padding: 8px 30px;
                                                            text-align: center;
                                                            text-decoration: none;
                                                            display: block;
                                                            font-size: 14px;
                                                            border-radius: 20px;
                                                            margin-left: 14%;
                                                            margin-top: 25px;background-color:rgb(214,180,105);
                                                            width: 200px;height: 35px;"/>
                                    </script>
                        </wx-open-launch-weapp>
                    </div>
                </div>
            </div>
            <!-- 中奖错误弹框结束 -->


            <!--活动规则开始-->
            <div v-if="showPopup">
                <div id="activityRule" class="modal" @click="closePopup()"></div>
                <div style="position: absolute;display: flex;justify-content: center;
                margin: -6% 0%; /* 上下自动，左右15% */
                border: 0px solid;
                text-align: center;z-index: 99;;width: 100%;height: 50px;opacity: 1;">
                    <div
                        style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
                        <p
                            style="background: url(/static/images/info-circle-o.png);background-size: cover;width: 35px;height: 35px;">
                        </p>
                    </div>
                </div>

                <div class="modal-content">
                    <!-- <span class="close" @click="closePopup()">&times;</span> -->
                    <p v-html="activityRule" style="margin-top:15px;color: white;"></p>
                </div>

            </div>
            <!--活动规则结束-->


            <div id="bottom_bar" style="position: absolute;bottom: 2rem;text-align: center;height: 20px;width: 100%;">
                <span style="text-align: center;color:#ffffff;" @click="openPopup">规则说明</span>
            </div>

        </div>
    </div>
</template>


<style scoped>
/* 背景遮罩 */
.modal {
    position: fixed;
    /* 固定位置 */
    z-index: 0;
    /* 位于顶层 */
    left: 0;
    top: 0;
    width: 100%;
    /* 宽度全屏 */
    height: 100%;
    /* 高度全屏 */
    overflow: auto;
    /* 超出内容可滚动 */
}

/* 模态内容 */
.modal-content {
    overflow: auto;
    background-color: #fefefe;
    margin: 50% auto;
    /* 上下自动，左右15% */
    padding: 24px;
    /* border: 1px solid rgb(214,180,105); */
    border: 0px solid;
    width: 85%;
    height: 300px;
    text-align: center;
    background-color: rgba(254, 251, 251, 0.2);
    z-index: 12;
    border-radius: 20px;
}

/* 模态内容 */
.modal-anti {
    overflow: auto;
    background-color: #fefefe;
    margin: 50% auto;
    /* 上下自动，左右15% */
    padding: 24px;
    /* border: 0px solid rgb(214,180,105); */
    border: 0px solid;
    width: 85%;
    height: 270px;
    text-align: center;
    background-color: rgba(254, 251, 251, 0.2);
    z-index: 12;
    border-radius: 20px;
}

.input {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
    font-weight: 500;
    font-size: 4vw;
    color: #fff;
    background-color: rgb(28, 28, 30);
    box-shadow: 0 0 .4vw rgba(0, 0, 0, 0.5), 0 0 0 .15vw transparent;
    border-radius: 2vw;
    border: none;
    outline: none;
    padding: 3vw;
    max-width: 210px;
    transition: .4s;
}

.input:hover {
    box-shadow: 0 0 0 .15vw rgba(5, 109, 213, 0.186);
}

.input:focus {
    box-shadow: 0 0 0 .15vw rgb(209, 181, 116);
}

.Btn-Container {
    margin-top: 20px;
    display: flex;
    width: 210px;
    height: fit-content;
    background-color: #1d2129;
    border-radius: 40px;
    justify-content: space-between;
    align-items: center;
    border: none;
    cursor: pointer;
}

.icon-Container {
    width: 40px;
    height: 38px;
    background-color: rgb(214,180,105);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 3px solid #1d2129;
}

.text {
    width: calc(170px - 45px);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.1em;
    letter-spacing: 1.2px;
}

.icon-Container svg {
    transition-duration: 1.5s;
}

.Btn-Container:hover .icon-Container svg {
    transition-duration: 1.5s;
    animation: arrow 1s linear infinite;
}

@keyframes arrow {
    0% {
        opacity: 0;
        margin-left: 0px;
    }

    100% {
        opacity: 1;
        margin-left: 10px;
    }
}
</style>
<script>

import { getAntiResult, getJSSDK, getWechatAuth, joinActivity, getInfoByCode, getTemplate, getScoreConfig, registerByOpenId, updateUserInfo } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
    data() {
        return {
            antiresult: "",
            productNo: null,
            productName: "",
            eno: "",
            deptId: 0,
            code: "",
            showPopup: false,
            activityRule: "",
            activityId: "",
            authCode: "",
            userToken: "",
            userMobile: "",
            userInfo: null,
            showActivity: false,
            showSuccessTip: false,
            showUserInfoSet: false,
            showErrorTip: false,
            isDisabled: false,
            getScoreTip: "",
            getScore: "",
            shopUrl: "",
            miniAppId: "",
            miniAppOriginalId: "",
            miniAppPage: "",
            showAntiPopup: true,
            antiQuery: false,
            errorTip: "抱歉<br/>此码已参与积分<br/>感谢您的支持",
            name: "",
            tel: ""
        };
    },
    methods: {
        async setUserInfo() {
            if (this.authCode == undefined || this.authCode == "" || this.authCode == null) {
                this.getAuth()
                return;
            }
            if (this.name == "" || this.tel == "") {
                alert("请正确填写用户信息");
            } else {
                const updateData = {
                    token: this.userToken,
                    userName: this.name,
                    tel: this.tel
                }
                await updateUserInfo(updateData).then(res => {
                    if (res.data.code == 200) {
                        this.joinActivity();
                    } else {
                        alert("用户信息更新异常");
                    }
                })
            }
        },
        getAuth() {
            const url = window.location.href.split('#')[0];
            sessionStorage.setItem("wechatAuth", true);
            getWechatAuth(url, "wxbc22565b3e7a59fd", 1).then(res => {
                const data = res.data;
                window.location.href = data;
            }).catch(err =>
                alert("获取微信授权失败" + err)
            )
        },
        async joinActivity() {
            this.isDisabled = true;
            if (this.authCode == undefined || this.authCode == "" || this.authCode == null) {
                this.getAuth()
                return;
            }

            await registerByOpenId(this.eno, this.authCode).then(res => {
                this.userToken = res.data.data.token;
                this.userMobile = res.data.data.tel;
                this.userInfo = res.data.data;
                if (this.userMobile == null) {
                    this.showUserInfoSet = true;
                    this.showSuccessTip = false;
                    this.showAntiPopup = false;
                    this.showPopup = false;
                    this.showErrorTip = false;
                    return;
                }
            })


            if (this.userMobile != null) {
                const data = {
                    code: this.code,
                    activityId: this.activityId,
                    authCode: this.authCode,
                    userToken: this.userToken
                }
                await joinActivity(data).then(res => {
                    //alert(JSON.stringify(res));
                    this.showUserInfoSet = false;
                    if (res.data.code == "200") {
                        this.getScoreTip = "恭喜您获得" + res.data.data.giftValue + "积分"
                        this.getScore = res.data.data.giftValue;
                        this.showSuccessTip = true;
                        this.showAntiPopup = false;
                        this.showUserInfoSet = false;
                        this.showPopup = false;
                        this.showErrorTip = false;

                    } else if (res.data.code == "500001") {
                        this.errorTip = "抱歉<br/>此码已参与积分<br/>感谢您的支持"
                        this.showAntiPopup = false;
                        this.showPopup = false;
                        this.showErrorTip = true;
                        this.showUserInfoSet = false;
                        this.showSuccessTip = false;
                    } else {
                        this.errorTip = res.data.message
                        this.showAntiPopup = false;
                        this.showPopup = false;
                        this.showErrorTip = true;
                        this.showUserInfoSet = false;
                        this.showSuccessTip = false;
                    }
                })
                this.isDisabled = false;
                sessionStorage.removeItem("wechatAuth");
            }
        },
        async getCodeInfo() {
            this.code = this.$route.query.c
            this.authCode = this.$route.query.wyAuthCode
            await getInfoByCode(this.$route.query.c).then(res => {
                this.eno = res.data.data.code
                console.log(this.eno)
                this.deptId = res.data.data.deptId
                this.productNo = res.data.data.productNo
                this.productName = res.data.data.productName
                if (this.productNo != null) {
                    this.showActivity = true;
                }

            })
        },
        async getTemplate() {
            await getTemplate(this.deptId).then(res => {
                this.activityId = res.data.data.activityId;
                this.activityRule = res.data.data.activityRule;
            })
        },
        async getScoreConfig() {
            getScoreConfig(this.deptId).then(res => {
                this.shopUrl = res.data.data.shopUrl
                const data = this.shopUrl.split('|')
                this.miniAppId = data[0]
                this.miniAppOriginalId = data[1]
                this.miniAppPage = data[2]
            })
        },
        openPopup() {
            this.showAntiPopup = false;
            this.showPopup = true;
            this.showErrorTip = false;
            this.showSuccessTip = false;
            this.showUserInfoSet = false;
        },
        closePopup() {
            this.showPopup = false;
            this.showAntiPopup = true;
            this.showErrorTip = false;
            this.showSuccessTip = false;
            this.showUserInfoSet = false;
        },
        async getResult() {
            const params = this.$route.query;
            const code = params.c;
            const antiQueryResult = sessionStorage.getItem("antiQueryResult");
            if (antiQueryResult != null) {
                this.antiresult = antiQueryResult
                return;
            }
            getAntiResult(code).then(res => {
                const data = res.data;
                if (data == null || data.code == "500") {
                    alert("防伪查询失败,请联系管理员");
                } else {
                    this.antiresult = data.message
                    this.antiQuery = true
                    sessionStorage.setItem("antiQueryResult", this.antiresult)
                }
            }).catch(err =>
                alert("查询异常，请联系管理员")
            )



        },
        async getConfig() {
            await this.getCodeInfo()
            await this.getScoreConfig()
            await this.getTemplate();
            const wechatAuth = sessionStorage.getItem("wechatAuth");
            if (wechatAuth == "true") {
                await this.joinActivity()
                return;
            }
        },
        getWxJs() {
            const url = encodeURIComponent(window.location.href.split('#')[0])
            getJSSDK(url, "wxbc22565b3e7a59fd").then(res => {
                console.log(res)
                const data = res.data.data
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.appId, // 必填，公众号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature,// 必填，签名，见附录1
                    openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
                    jsApiList: [
                        'checkJsApi',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'onMenuShareQZone',
                        'hideMenuItems',
                        'showMenuItems',
                        'hideAllNonBaseMenuItem',
                        'showAllNonBaseMenuItem',
                        'translateVoice',
                        'startRecord',
                        'stopRecord',
                        'onVoiceRecordEnd',
                        'playVoice',
                        'onVoicePlayEnd',
                        'pauseVoice',
                        'stopVoice',
                        'uploadVoice',
                        'downloadVoice',
                        'chooseImage',
                        'previewImage',
                        'uploadImage',
                        'downloadImage',
                        'getNetworkType',
                        'openLocation',
                        'getLocation',
                        'hideOptionMenu',
                        'showOptionMenu',
                        'closeWindow',
                        'scanQRCode',
                        'chooseWXPay',
                        'openProductSpecificView',
                        'addCard',
                        'chooseCard',
                        'openCard'
                    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
                wx.ready(function () {
                    wx.hideMenuItems({
                        menuList: [
                            'menuItem:copyUrl',
                            'menuItem:openWithQQBrowse',
                            'menuItem:openWithSafari',
                            'menuItem:email',
                            'menuItem:readMode',
                            'menuItem:originPage',
                            'menuItem:delete',
                            'menuItem:editTag'
                        ]
                    });
                });

            }).catch(err =>
                alert("获取微信授权失败" + err)
            )
        }
    },
    mounted: function () {
        this.getWxJs()
        this.getResult()
    },
    created: function () {
        this.getConfig();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/XinHengFeng/Index.vue